var _g, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ICON_bell",
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.918,
    height: 55.918,
    viewBox: "0 0 55.918 55.918",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notifications_none-24px",
    transform: "matrix(0.891, 0.454, -0.454, 0.891, 18.875, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_721",
    "data-name": "Pfad 721",
    d: "M0,0H41.575V41.575H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_722",
    "data-name": "Pfad 722",
    d: "M17.858,36.28a3.475,3.475,0,0,0,3.465-3.465H14.394A3.475,3.475,0,0,0,17.858,36.28ZM28.252,25.886V17.225c0-5.318-2.824-9.77-7.8-10.948V5.1a2.6,2.6,0,0,0-5.2,0V6.276c-4.954,1.178-7.8,5.613-7.8,10.948v8.661L4,29.351v1.732H31.717V29.351ZM26.175,27.7l-16.1.29-.19-10.465c0-4.3,1.48-8.462,7.522-8.986s8.124,4.372,8.124,8.668Z",
    transform: "translate(2.929 1.831)",
    fill: "#5c5b5b"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_723",
    "data-name": "Pfad 723",
    d: "M1692.242,235.949a8.841,8.841,0,0,1,.119,8.515",
    transform: "translate(-1649.2 -214.242)",
    fill: "none",
    stroke: "#5c5b5b",
    strokeLinecap: "round",
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_724",
    "data-name": "Pfad 724",
    d: "M1693.369,235.949a8.841,8.841,0,0,0-.119,8.515",
    transform: "translate(-907.689 -1420.202) rotate(49)",
    fill: "none",
    stroke: "#5c5b5b",
    strokeLinecap: "round",
    strokeWidth: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_725",
    "data-name": "Pfad 725",
    d: "M1693.042,236.621s-.939,3.817.748,6.144",
    transform: "translate(-910.597 -1421.544) rotate(49)",
    fill: "none",
    stroke: "#5c5b5b",
    strokeLinecap: "round",
    strokeWidth: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_726",
    "data-name": "Pfad 726",
    d: "M1672.031,221.739a5.378,5.378,0,0,1,2.174-.645",
    transform: "translate(-1649.2 -211.082)",
    fill: "none",
    stroke: "#5c5b5b",
    strokeLinecap: "round",
    strokeWidth: 1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBell);
export default __webpack_public_path__ + "static/media/icon_bell.5c682286e2f3ac01e4eac03930dc2dc7.svg";
export { ForwardRef as ReactComponent };